import { PropAsset } from './PropAsset';

// Pine Tree - Çam Ağacı (Canvas2D)
export class TreePine extends PropAsset {
  readonly id = 'tree_pine';
  readonly width = 55;
  readonly height = 100;
  readonly walkable = false;
  readonly collisionRadius = 0.4;
  readonly occludesPlayer = true;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, _variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.2)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 12 * s, 6 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Trunk - Gövde
    ctx.fillStyle = '#4a3628';
    ctx.fillRect(cx - 4 * s, cy - 35 * s, 8 * s, 35 * s);

    // Trunk bark detail - Kabuk detayları
    ctx.strokeStyle = '#3a2a1a';
    ctx.lineWidth = 1 * s;
    // Vertical grain lines
    ctx.beginPath();
    ctx.moveTo(cx - 1 * s, cy - 33 * s);
    ctx.lineTo(cx - 1.5 * s, cy - 5 * s);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(cx + 2 * s, cy - 30 * s);
    ctx.lineTo(cx + 1.5 * s, cy - 8 * s);
    ctx.stroke();
    // Knot mark
    ctx.fillStyle = '#3a2a1a';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 18 * s, 2 * s, 1.5 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Foliage layers - Yaprak katmanları
    ctx.fillStyle = '#1a4a1a';

    // Top triangle
    ctx.beginPath();
    ctx.moveTo(cx, cy - 70 * s);
    ctx.lineTo(cx - 12 * s, cy - 45 * s);
    ctx.lineTo(cx + 12 * s, cy - 45 * s);
    ctx.closePath();
    ctx.fill();

    // Middle triangle
    ctx.beginPath();
    ctx.moveTo(cx, cy - 55 * s);
    ctx.lineTo(cx - 16 * s, cy - 30 * s);
    ctx.lineTo(cx + 16 * s, cy - 30 * s);
    ctx.closePath();
    ctx.fill();

    // Bottom triangle
    ctx.beginPath();
    ctx.moveTo(cx, cy - 40 * s);
    ctx.lineTo(cx - 18 * s, cy - 15 * s);
    ctx.lineTo(cx + 18 * s, cy - 15 * s);
    ctx.closePath();
    ctx.fill();

    // Snow on top (variant 1)
    if (_variant === 1) {
      ctx.fillStyle = '#ffffff';
      ctx.beginPath();
      ctx.moveTo(cx, cy - 70 * s);
      ctx.lineTo(cx - 6 * s, cy - 55 * s);
      ctx.lineTo(cx + 6 * s, cy - 55 * s);
      ctx.closePath();
      ctx.fill();
    }
  }
}
